export const GET_LOGS = 'logsEpic/GET_LOGS';
export const GET_LOGS_SUCCESS = 'logsEpic/GET_LOGS_SUCCESS';
export const GET_LOGS_ERROR = 'logsEpic/GET_LOGS_ERROR';

export const FILTER_LOGS = 'logsEpic/FILTER_LOGS';
